import React, { useContext } from "react";
import PropTypes from "prop-types";
import PostCard from "PostCard";
import Select from "react-select";
import { Shimmer } from "Shimmers";
import "./styles.scss";
import { UserContext } from "UserContext";

const PostsFeed = ({
  posts,
  postsRequestStatus,
  company,
  setPostSectionsFilter,
  showPostPortfolioRecipientsIndicator = false,
  fetchNextPage,
  hasNextPage,
  isFetchingNextPage,
  onCompanyDetailPage = false,
}) => {
  const postSectionDisplayHeaderOptions = [
    { value: "", label: "All Sections" },
    { value: "appreciation", label: "📢 Shout Outs" },
    { value: "achievements", label: "🏆 Achievements" },
    { value: "announcements", label: "🎙️ Announcements" },
    { value: "asks", label: "🙏 Asks" },
    { value: "product", label: "🖥 Product" },
    { value: "challenges", label: "🏋 Challenges" },
    { value: "strategy", label: "🎯 Strategy" },
    { value: "financials", label: "💰 Financials" },
    { value: "kpis", label: "📈 KPIs" },
  ];

  const handlePostSectionFilterChange = (e) => {
    setPostSectionsFilter([e.value]);
  };
  

  const [userContext, dispatchUserContext] = useContext(UserContext);

  let userIsAdmin = false;
  if (userContext.companiesUserHasAdminAccessTo) {
    let companyIdsUserHasAdminAccessTo =
      userContext.companiesUserHasAdminAccessTo.map(
        (company) => company.company_id
      );

    if (companyIdsUserHasAdminAccessTo.includes(company.company_id)) {
      userIsAdmin = true;
    }
  }

  const customStyles = {
    control: (styles) => ({
      ...styles,
      cursor: "pointer",
      border: "transparent",
      borderColor: "transparent",
      // borderLeft: "1px solid gray",
      boxShadow: "none",
      ":hover": {
        pointer: "cursor",
        boxShadow: "none",
        borderColor: "transparent",
        // borderLeft: "1px solid gray",
      },
    }),
    container: (styles) => ({
      ...styles,
      width: "200px",
      ":focus": {
        borderColor: "transparent",
      },
      border: "transparent",
      borderColor: "transparent",
    }),
  };

  return (
    <React.Fragment>
      <div>
        <div
          className="ps-posts-feed__header"
          style={{ marginTop: onCompanyDetailPage === true ? "-55px" : "" }}
        >
          {/* <div className="ps-posts-feed__header-text-container">
            <span className="ps-posts-feed__header-text">Updates</span>
          </div> */}
          <div className="ps-posts-feed__filter">
            <Select
              defaultValue={postSectionDisplayHeaderOptions[0]}
              onChange={handlePostSectionFilterChange}
              options={postSectionDisplayHeaderOptions}
              className={""}
              styles={customStyles}
            ></Select>
          </div>
        </div>
      </div>
      <div style={{ paddingBottom: "17px" }}>
        <div>
          {postsRequestStatus == "success" && posts && posts.length === 0 && (
            <div className="ps-empty-company-posts">
              <img
                className="ps-empty-company-posts__icon"
                src="/dist/clientlibs/assets/img/gray-square-lock-icon.png"
              />

              <div className="ps-empty-company-posts__text-heading">
                <span>No Company Updates</span>
              </div>

              <div className="ps-empty-company-posts__text-sub-heading">
                <span>
                  {`${company.display_name} has not posted any company updates yet.`}
                </span>
              </div>
            </div>
          )}
          {posts &&
            posts.map((post, i) => {
              if (company && post.company_id !== company.company_id) {
                return;
              }
              return (
                <PostCard
                  key={post.post_id + `${i}`}
                  post={post}
                  userIsAdmin={userIsAdmin}
                  company={company}
                  showPostPortfolioRecipientsIndicator={
                    showPostPortfolioRecipientsIndicator
                  }
                />
              );
            })}
          {(postsRequestStatus == "loading" ||
            postsRequestStatus == "idle" ||
            isFetchingNextPage) &&
            [1, 2, 3, 4].map((item, index) => (
              <div className="ps-card--primary ps-post-card" key={index}>
                <div className="ps-post-card__header-container">
                  <div
                    className="ps-post-card__author-title-container"
                    style={{ width: "100%" }}
                  >
                    <Shimmer
                      shimmerStyles={{
                        marginTop: "15px",
                        marginBottom: "15px",
                        height: "25px",
                        width: "50%",
                        borderRadius: "4px",
                      }}
                    />
                    <Shimmer
                      shimmerStyles={{
                        marginTop: "7px",
                        marginBottom: "10px",
                        height: "15px",
                        width: "25%",
                        borderRadius: "4px",
                      }}
                    />
                    <div className="ps-post-card__sub-title-container"></div>
                  </div>
                  <div className="ps-post-card__date-options-container">
                    {/* <div className="ps-post-card__date-text">{publishedTimestamp}</div> */}
                  </div>
                </div>

                <div className="ps-card--update-body">
                  <div className="d-flex flex-row">
                    <div>
                      {/* <img
                      style=""
                      className="ps-card__circle-avatar-image-fifty"
                      src={post.postAuthor.profile_image_url}
                    /> */}
                    </div>
                  </div>

                  <hr className="ps-divider--secondary my-4" />

                  <div
                    className={"d-flex flex-column"}
                    style={{ marginBottom: "30px" }}
                  >
                    <div className={"d-flex flex-row"}>
                      <Shimmer
                        shimmerStyles={{
                          marginTop: "15px",
                          width: "50px",
                          height: "50px",
                          borderRadius: "50%",
                        }}
                      ></Shimmer>
                      <Shimmer
                        shimmerStyles={{
                          marginTop: "30px",
                          marginLeft: "18px",
                          width: "24%",
                          height: "14px",
                          borderRadius: "5px",
                        }}
                      ></Shimmer>
                    </div>
                    <div className={"d-flex flex-column"}>
                      <Shimmer
                        shimmerStyles={{
                          marginTop: "40px",
                          width: "95%",
                          height: "14px",
                          borderRadius: "5px",
                        }}
                      ></Shimmer>
                      <Shimmer
                        shimmerStyles={{
                          marginTop: "15px",
                          width: "95%",
                          height: "14px",
                          borderRadius: "5px",
                        }}
                      ></Shimmer>
                      <Shimmer
                        shimmerStyles={{
                          marginTop: "15px",
                          width: "55%",
                          height: "14px",
                          borderRadius: "5px",
                        }}
                      ></Shimmer>
                    </div>
                    <div className={"d-flex flex-column"}>
                      <Shimmer
                        shimmerStyles={{
                          marginTop: "45px",
                          width: "20%",
                          height: "22px",
                          borderRadius: "5px",
                        }}
                      ></Shimmer>
                      <Shimmer
                        shimmerStyles={{
                          marginTop: "20px",
                          width: "95%",
                          height: "14px",
                          borderRadius: "5px",
                        }}
                      ></Shimmer>
                      <Shimmer
                        shimmerStyles={{
                          marginTop: "15px",
                          width: "95%",
                          height: "14px",
                          borderRadius: "5px",
                        }}
                      ></Shimmer>
                      <Shimmer
                        shimmerStyles={{
                          marginTop: "15px",
                          width: "95%",
                          height: "14px",
                          borderRadius: "5px",
                        }}
                      ></Shimmer>
                      <Shimmer
                        shimmerStyles={{
                          marginTop: "15px",
                          width: "55%",
                          height: "14px",
                          borderRadius: "5px",
                        }}
                      ></Shimmer>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          {posts && hasNextPage && !isFetchingNextPage && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <button
                onClick={() => {
                  fetchNextPage();
                }}
                className={"btn ps-btn--white mt-3 mb-3"}
                disabled={!hasNextPage || isFetchingNextPage}
              >
                {isFetchingNextPage
                  ? "Loading more..."
                  : hasNextPage
                  ? "Load More"
                  : "Nothing more to load"}
              </button>
            </div>
          )}

          {/* {posts && totalPostCount && totalPostCount > posts.length && (
            <div
              onClick={() => {
                console.log("great");
                console.log(limit);
                setLimit((limit)=>{return limit + 6});
              }}
            >
              {"Load More"}
            </div>
          )} */}
        </div>
      </div>
    </React.Fragment>
  );
};

PostsFeed.propTypes = {
  posts: PropTypes.array,
  postSectionsFilter: PropTypes.array,
  setPostSectionsFilter: PropTypes.func,
  showPostPortfolioRecipientsIndicator: PropTypes.bool,
};

export default PostsFeed;
